import { useState } from 'react';
import ContactModal from './ContactModal';

export default function Footer() {
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);

  return (
    <>
      <footer className="relative bg-[#0a1628] border-t border-[#DC2626]/20 py-12 pb-32">
        <div className="max-w-7xl mx-auto px-6">
          {/* Main Footer Content */}
          <div className="grid md:grid-cols-3 gap-12 mb-12">
            {/* Column 1 - Brand */}
            <div>
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 flex items-center justify-center">
                  <i className="ri-shield-fill text-3xl text-[#DC2626]"></i>
                </div>
                <h3 className="text-white font-black text-xl" style={{ fontFamily: "'Oswald', sans-serif" }}>
                  BULLY PROOF MY LIFE
                </h3>
              </div>
              <p className="text-gray-400 text-base leading-relaxed">
                Walk through life with a Rottweiler on a leash. Legal protection for $30/month.
              </p>
            </div>

            {/* Column 2 - Quick Links */}
            <div>
              <h4 className="text-white font-black text-lg mb-4">Quick Links</h4>
              <ul className="space-y-3">
                <li>
                  <a href="/" className="text-gray-400 hover:text-[#DC2626] transition-colors cursor-pointer text-base">
                    Home
                  </a>
                </li>
                <li>
                  <a href="/about" className="text-gray-400 hover:text-[#DC2626] transition-colors cursor-pointer text-base">
                    My $4,500 Mistake
                  </a>
                </li>
                <li>
                  <a href="#faq" className="text-gray-400 hover:text-[#DC2626] transition-colors cursor-pointer text-base">
                    FAQ
                  </a>
                </li>
                <li>
                  <a 
                    href="https://www.legalshield.com/info/business-opportunity" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="text-gray-500 hover:text-gray-400 transition-colors cursor-pointer text-sm"
                  >
                    Business Opportunity
                  </a>
                </li>
                <li>
                  <a href="/dashboard/login" className="text-gray-500 hover:text-gray-400 transition-colors cursor-pointer text-sm">
                    Admin
                  </a>
                </li>
              </ul>
            </div>

            {/* Column 3 - Contact */}
            <div>
              <h4 className="text-white font-black text-lg mb-4">Contact</h4>
              <p className="text-gray-400 text-base leading-relaxed mb-4">
                Questions about coverage or which plan is right for you?
              </p>
              <p className="text-gray-400 text-base">
                Email: <button 
                  onClick={() => setIsContactModalOpen(true)}
                  className="text-[#DC2626] hover:text-[#B91C1C] cursor-pointer underline bg-transparent border-none p-0"
                >
                  Contact Us
                </button>
              </p>
            </div>
          </div>

          {/* Divider */}
          <div className="border-t border-[#DC2626]/20 pt-8">
            {/* Affiliate Disclosure */}
            <div className="mb-6">
              <p className="text-gray-500 text-sm leading-relaxed max-w-4xl">
                <strong className="text-gray-400">Affiliate Disclosure:</strong> Epic Real Estate is an independent affiliate of LegalShield. 
                This means I earn a commission if you purchase a membership through my links. I only recommend products I personally use 
                and believe in. Your cost is the same whether you buy through my link or directly from LegalShield. I'm sharing this 
                because it genuinely saved me $4,500 and gives me leverage I didn't have before.
              </p>
            </div>

            {/* Copyright */}
            <div className="flex flex-col md:flex-row justify-between items-center gap-4">
              <p className="text-gray-500 text-sm">
                © {new Date().getFullYear()} Bully Proof My Life. All rights reserved.
              </p>
              <div className="flex items-center gap-6">
                <a href="#" className="text-gray-500 hover:text-gray-400 text-sm cursor-pointer">
                  Privacy Policy
                </a>
                <a href="#" className="text-gray-500 hover:text-gray-400 text-sm cursor-pointer">
                  Terms of Service
                </a>
              </div>
            </div>
          </div>
        </div>
      </footer>

      <ContactModal isOpen={isContactModalOpen} onClose={() => setIsContactModalOpen(false)} />
    </>
  );
}
